import { DeleteOutlined, DownloadOutlined, EditOutlined, ReloadOutlined, SaveOutlined, ArrowLeftOutlined, PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Row, Select, Space, Table, Tabs, Tag } from "antd";
import Checkbox from 'antd/es/checkbox/Checkbox';
import Column from 'antd/es/table/Column';
import ColumnGroup from 'antd/lib/table/ColumnGroup';
import dayjs from 'dayjs';
import { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from "react-toastify";
import { ContentHeader } from '../../../components';
import ModalTextForm from '../../../components/modal/ModalTextForm';
import { Links } from '../../../helpers/Links';
import { currencyFormat, dateCommon, formatVND, parseThangTuMang, validateMessages } from '../../../helpers/common';
import { ChiTietDuocNhanKCT } from '../../../models/luong/ThuLaoKCT';
import { DataSelectBox } from '../../../models/selectbox';
import { convertDataDsThuLaoKhongChuyenTrach, luuThuLaoKCT, thuLaoKhongChuyenTrachGetById, tinhThuLaoKCT, xacNhanThuLaoKhongChuyenTrach, xoaThuLaoKhongChuyenTrach, xuatExcelThuLaoKhongChuyenTrach } from '../../../services/thulaokhongchuyentrach';
import { hideLoadingScreen, showLoadingScreen } from '../../../store/reducers/loading';
import { layThongTinCauHinh } from '../../../services/setting';
import { soNgayCongMacDinh } from '../../../constants';

const optionsLoai = [
    {
        value: 3,
        label: "Tạm ứng"
    },
    {
        value: 1,
        label: "Điều chỉnh/Bổ sung"
    },
    {
        value: 2,
        label: "Quyết toán"
    },
    {
        value: 0,
        label: "Thù lao Quý (cách tính cũ)"
    },
]

const { RangePicker } = DatePicker;

const ChiTietThuLaoKCT = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [form] = Form.useForm();
    const watchTenTieuDeCot = Form.useWatch('tenTieuDeCot', form);
    const watchGhiChu = Form.useWatch('ghiChu', form);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [id, setId] = useState<number>(0);
    const [loaiThuLao, setLoaiThuLao] = useState<number>(0);
    const [isTinhChiTiet, setIsTinhChiTiet] = useState<boolean>(false);

    const [showModalDelete, setShowModalDelete] = useState<boolean>(false);
    const [showModalDuyet, setShowModalDuyet] = useState<boolean>(false);

    const [isTinhPhanTram, setIsTinhPhanTram] = useState<boolean>(false);

    const [dataThuLaoKCT, setDataThuLaoKCT] = useState<Array<any>>([]);
    const [optionDieuChinh, setOptionDieuChinh] = useState<Array<DataSelectBox>>([]);
    const [chiTietDuocNhan, setChiTietDuocNhan] = useState<Array<ChiTietDuocNhanKCT>>([]);
    const [listId, setListId] = useState<Array<number>>([]);
    const [quy, setQuy] = useState(-1);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [trangThai, setTrangThai] = useState<number>(-1);

    const handleChangeCurrency = (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            thuLaoBinhQuanMotThang: parsedValue,
            thuLaoBinhQuanMotThangStr: format
        });
    };

    const handleChangeCurrencyCommon = (fieldName: string, formattedFieldName: string) => (e: any) => {
        e.preventDefault();
        const { value } = e.target;
        const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
        var format = currencyFormat.formatMoney(parsedValue);
        form.setFieldsValue({
            [fieldName]: parsedValue,
            [formattedFieldName]: format
        });
    };

    const eventXacNhan = async () => {
        try {
            setShowModalDuyet(false);
            dispatch(showLoadingScreen());
            await xacNhanThuLaoKhongChuyenTrach(id);
            navigate(Links.ThuLaoKhongChuyenTrach.DanhSach);
            toast.success("Xác nhận thù lao HĐQL không chuyên trách thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const eventSaveThuLaoKCT = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            try {
                if (dataThuLaoKCT.length <= 0) {
                    toast.error("Không có dữ liệu tính thù lao HĐQL không chuyên trách");
                }
                else {
                    var request: any = {
                        id: id,
                        ten: values.ten,
                        tenTieuDeCot: values.tenTieuDeCot,
                        ghiChu: values.ghiChu,
                        thangNam: values.thangNam,
                        loaiThuLao: values?.loaiThuLao,
                        quy: loaiThuLao >= 1 ? 0 : values?.thoiGianQuyetToanQuy?.$M / 3 + 1,
                        nam: loaiThuLao >= 1 ? values?.thoiGianQuyetToanNam?.$y : values?.thoiGianQuyetToanQuy?.$y,
                        mucTienNhapVao: values?.thuLaoBinhQuanMotThang != null ? parseInt(values?.thuLaoBinhQuanMotThang) : 0,
                        mucThuLaoCTHDQL: values?.mucThuLaoCTHDQL != null ? parseInt(values?.mucThuLaoCTHDQL) : 0,
                        mucThuLaoPCTHDQL: values?.mucThuLaoPCTHDQL != null ? parseInt(values?.mucThuLaoPCTHDQL) : 0,
                        mucThuLaoTVHDQL: values?.mucThuLaoTVHDQL != null ? parseInt(values?.mucThuLaoTVHDQL) : 0,
                        soThangLamViec: values?.soThangLamViec != null ? parseInt(values?.soThangLamViec) : (loaiThuLao === 2 ? 12 : 3),
                        dsThuLaoKhongChuyenTrach: dataThuLaoKCT,
                        listId: loaiThuLao >= 1 ? values?.dsQuyDieuChinh : null,
                        isTinhPhanTram: loaiThuLao >= 1 ? false : isTinhPhanTram,
                        isTinhChiTiet: isTinhChiTiet,
                        quyThuLaoThangDau: values?.thuLaoBinhQuanThangDau != null ? parseInt(values?.thuLaoBinhQuanThangDau) : 0,
                        quyThuLaoThangGiua: values?.thuLaoBinhQuanThangGiua != null ? parseInt(values?.thuLaoBinhQuanThangGiua) : 0,
                        quyThuLaoThangCuoi: values?.thuLaoBinhQuanThangCuoi != null ? parseInt(values?.thuLaoBinhQuanThangCuoi) : 0,
                    };
                    const savedId = await luuThuLaoKCT(request);
                    toast.success("Lưu thù lao HĐQL không chuyên trách thành công");
                    const targetId = savedId || id;
                    if (targetId) {
                        navigate(`${Links.ThuLaoKhongChuyenTrach.ChiTiet}?id=${targetId}`);
                        getById(targetId);
                    }
                }
            } catch (error: any) {
                toast.error(error.message);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra!");
        });
    }

    const eventDelete = async () => {
        try {
            setShowModalDelete(false);
            dispatch(showLoadingScreen());
            await xoaThuLaoKhongChuyenTrach(id);
            navigate(Links.ThuLaoKhongChuyenTrach.DanhSach);
            toast.success("Xóa lương thù lao HĐQL không chuyên trách thành công");
        }
        catch (e: any) {
            toast.error(e);
        }
        dispatch(hideLoadingScreen());
    }

    const getById = async (id: any) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            var response = await thuLaoKhongChuyenTrachGetById(id);
            loadData(response);
        }
        catch (e: any) {
            toast.error(e)
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }

    const recalculateRow = (record: any) => {
        const mucLuongCB = Number(record.mucLuongCB) || 0;
        const tyLe = record.tyLe ?? 1;
        const thuLaoTamUngMotThang = Math.round(mucLuongCB * tyLe);
        record.thuLaoTamUngMotThang = thuLaoTamUngMotThang;

        if (loaiThuLao === 3) {
            const soNgayThucTe = record.soNgayThucTe !== undefined && record.soNgayThucTe !== null ? Number(record.soNgayThucTe) : soNgayCongMacDinh;
            const soNgayQuyDinh = Number(record.soNgayQuyDinh) > 0 ? Number(record.soNgayQuyDinh) : soNgayCongMacDinh;
            record.soNgayThucTe = soNgayThucTe;
            record.soNgayQuyDinh = soNgayQuyDinh;
            record.soThangLamViec = 1;
            record.soThangTron = 1;
            const soTienDuocNhan = Math.round(thuLaoTamUngMotThang * soNgayThucTe / soNgayQuyDinh);
            record.soTienDuocNhan = soTienDuocNhan;
            record.soTienDaNhan = 0;
            record.soTienConDuocNhan = soTienDuocNhan;
            return;
        }

        const soThangTron = Number(record.soThangTron) || 0;
        const dsThangKhongTron = record.dsThangKhongTron || [];

        let tongThangLe = 0;
        let tongTienThangLe = 0;

        dsThangKhongTron.forEach((item: any) => {
            const soThang = Number(item.soThang) || 0;
            const soNgayThucTe = Number(item.soNgayThucTe) || 0;
            const soNgayQuyDinh = Number(item.soNgayQuyDinh) > 0 ? Number(item.soNgayQuyDinh) : soNgayCongMacDinh;
            tongThangLe += soThang;
            tongTienThangLe += Math.round(thuLaoTamUngMotThang * soThang * (soNgayThucTe / soNgayQuyDinh));
        });

        record.soThangLamViec = soThangTron + tongThangLe;
        const soTienDuocNhan = Math.round(thuLaoTamUngMotThang * soThangTron) + tongTienThangLe;
        record.soTienDuocNhan = soTienDuocNhan;

        const soTienDaNhan = Number(record.soTienDaNhan) || 0;
        record.soTienConDuocNhan = soTienDuocNhan - soTienDaNhan;
    };

    const taiDuLieu = async () => {
        if (isLoading) return;
        form.validateFields().then(async (values) => {
            dispatch(showLoadingScreen());
            setIsLoading(true);
            const namQuyetToan = loaiThuLao >= 1 ? form.getFieldsValue(['thoiGianQuyetToanNam'])?.thoiGianQuyetToanNam?.$y : form.getFieldsValue(['thoiGianQuyetToanQuy'])?.thoiGianQuyetToanQuy?.$y;
            const quyQuyetToan = loaiThuLao >= 1 ? 0 : form.getFieldsValue(['thoiGianQuyetToanQuy'])?.thoiGianQuyetToanQuy?.$M / 3 + 1;
            setQuy(quyQuyetToan);
            try {
                if (isTinhChiTiet && chiTietDuocNhan.some((x) => x.quyThuLaoThang === 0)) {
                    throw "Bạn chưa nhập đủ quỹ thù lao hàng tháng";
                }
                var request = {
                    thuLaoBinhQuanMotThang: values?.thuLaoBinhQuanMotThang != null ? parseInt(values?.thuLaoBinhQuanMotThang) : 0,
                    mucThuLaoCTHDQL: values?.mucThuLaoCTHDQL != null ? parseInt(values?.mucThuLaoCTHDQL) : 0,
                    mucThuLaoPCTHDQL: values?.mucThuLaoPCTHDQL != null ? parseInt(values?.mucThuLaoPCTHDQL) : 0,
                    mucThuLaoTVHDQL: values?.mucThuLaoTVHDQL != null ? parseInt(values?.mucThuLaoTVHDQL) : 0,
                    soThangLamViec: values?.soThangLamViec != null ? parseInt(values?.soThangLamViec) : (loaiThuLao === 2 ? 12 : 3),
                    tenTieuDeCot: values?.tenTieuDeCot,
                    listId: loaiThuLao >= 1 ? values?.dsQuyDieuChinh : null,
                    loaiTinh: loaiThuLao,
                    isTinhPhanTram: isTinhPhanTram,
                    isTinhChiTiet: isTinhChiTiet,
                    chiTietDuocNhan: isTinhChiTiet ? chiTietDuocNhan : null
                }
                var data = await tinhThuLaoKCT(request);
                const dsKCT = (data || []).map((item: any) => {
                    if (item.soThangTron === undefined || item.soThangTron === null) {
                        item.soThangTron = item.soThangLamViec || 0;
                    }
                    if (item.soNgayThucTe === undefined || item.soNgayThucTe === null) {
                        item.soNgayThucTe = soNgayCongMacDinh;
                    }
                    if (item.soNgayQuyDinh === undefined || item.soNgayQuyDinh === null) {
                        item.soNgayQuyDinh = soNgayCongMacDinh;
                    }
                    if (!item.dsThangKhongTron) {
                        item.dsThangKhongTron = [];
                    }
                    if (item.soTienDaNhan === undefined || item.soTienDaNhan === null) {
                        item.soTienDaNhan = (item.chiTietDaNhan || []).reduce((sum: number, c: any) => sum + (c.mucTien || 0), 0);
                    }
                    return item;
                });
                setDataThuLaoKCT(dsKCT);
            } catch (e: any) {
                toast.error(e);
            }
            dispatch(hideLoadingScreen());
            setIsLoading(false);
        }).catch((e) => {
            toast.error("Có lỗi xảy ra. Vui lòng thử lại sau.");
        });
    }

    const loadData = (response: any) => {
        setId(response.id);
        var format = currencyFormat.formatMoney(response.mucTienNhapVao + "");
        var chiTietDuocNhanResponse = response.dsThuLaoKhongChuyenTrach[0]?.chiTietDuocNhan
        getDataSelectThuLaoKCT(response?.nam);

        var dform: any = {
            id: response.id,
            ten: response.ten,
            tenTieuDeCot: response.tenTieuDeCot || `Mức thù lao kế hoạch theo chức danh/tháng (năm ${response.nam || dayjs().year()})`,
            ghiChu: response.ghiChu || '',
            thangNam: response.thangNam != null ? dayjs(dateCommon.formatDate(new Date(response.thangNam), "dd/MM/yyyy"), "DD/MM/YYYY") : undefined,
            kyLuongNam: dayjs(new Date(response.nam, 1, 1)),
            thuLaoBinhQuanMotThang: response.mucTienNhapVao + "",
            thuLaoBinhQuanMotThangStr: format,
            mucThuLaoCTHDQL: (response.mucThuLaoCTHDQL ?? 0) + "",
            mucThuLaoCTHDQLStr: currencyFormat.formatMoney((response.mucThuLaoCTHDQL ?? 0) + ""),
            mucThuLaoPCTHDQL: (response.mucThuLaoPCTHDQL ?? 0) + "",
            mucThuLaoPCTHDQLStr: currencyFormat.formatMoney((response.mucThuLaoPCTHDQL ?? 0) + ""),
            mucThuLaoTVHDQL: (response.mucThuLaoTVHDQL ?? 0) + "",
            mucThuLaoTVHDQLStr: currencyFormat.formatMoney((response.mucThuLaoTVHDQL ?? 0) + ""),
            soThangLamViec: response.soThangLamViec || (response.loaiThuLao === 2 ? 12 : 3),
            trangThai: response.trangThai,
            thoiGianQuyetToanQuy: dayjs(dateCommon.formatDate(new Date(response?.nam, (response?.quy != null && response?.quy < 5) ? response?.quy * 3 - 3 : 6, 1)), "DD/MM/YYYY"),
            thoiGianQuyetToanNam: dayjs(dateCommon.formatDate(new Date(response?.nam, 6, 1)), "DD/MM/YYYY"),
            loaiThuLao: response.loaiThuLao,
            dsQuyDieuChinh: response.dsQuyDieuChinh || [],
            isTinhPhanTram: response.isTinhPhanTram,
            isTinhChiTiet: response.isTinhChiTiet,
            kyThaoTac: (chiTietDuocNhanResponse != null && chiTietDuocNhanResponse != undefined) ? [dayjs(dateCommon.formatDate(new Date(response?.nam, chiTietDuocNhanResponse[0]?.thang - 1, 1)), "DD/MM/YYYY"), dayjs(dateCommon.formatDate(new Date(response?.nam, chiTietDuocNhanResponse[chiTietDuocNhanResponse?.length - 1]?.thang - 1, 1)), "DD/MM/YYYY")] :
                undefined,
        };
        setTrangThai(response.trangThai);
        setLoaiThuLao(response.loaiThuLao);
        setIsTinhPhanTram(response.isTinhPhanTram);
        setIsTinhChiTiet(response.isTinhChiTiet);
        setChiTietDuocNhan(chiTietDuocNhanResponse != null ? chiTietDuocNhanResponse : []);
        setQuy(response.quy)
        form.setFieldsValue(dform);
        setIsEdit(false);
        const dsKCT = (response.dsThuLaoKhongChuyenTrach || []).map((item: any) => {
            if (item.soThangTron === undefined || item.soThangTron === null) {
                item.soThangTron = item.soThangLamViec || 0;
            }
            if (item.soNgayThucTe === undefined || item.soNgayThucTe === null) {
                item.soNgayThucTe = soNgayCongMacDinh;
            }
            if (item.soNgayQuyDinh === undefined || item.soNgayQuyDinh === null) {
                item.soNgayQuyDinh = soNgayCongMacDinh;
            }
            if (!item.dsThangKhongTron) {
                item.dsThangKhongTron = [];
            }
            if (item.soTienDaNhan === undefined || item.soTienDaNhan === null) {
                item.soTienDaNhan = (item.chiTietDaNhan || []).reduce((sum: number, c: any) => sum + (c.mucTien || 0), 0);
            }
            return item;
        });
        setDataThuLaoKCT(dsKCT);
    }

    const getDataSelectThuLaoKCT = async (nam: number) => {
        dispatch(showLoadingScreen());
        setIsLoading(true);
        try {
            setListId([]);
            setDataThuLaoKCT([]);
            form.setFieldsValue({
                dsQuyDieuChinh: []
            })
            var response = await convertDataDsThuLaoKhongChuyenTrach(nam);
            setOptionDieuChinh(response);
        }
        catch (e: any) {
            toast.error(e)
        }
        setIsLoading(false);
        dispatch(hideLoadingScreen());
    }
    const handleExport = async () => {
        dispatch(showLoadingScreen());
        try {
            var response = await xuatExcelThuLaoKhongChuyenTrach(id);
            let link = document.createElement('a');
            link.download = `${form.getFieldValue('ten') || 'ThuLaoHDQLKCT'}.xlsx`;
            let blob = new Blob([response.data], { type: response.data.type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            link.href = URL.createObjectURL(blob);
            link.click();
            URL.revokeObjectURL(link.href);
        } catch (ex) {
            toast.error("Xuất báo không thành công. Vui lòng thử lại");
        }

        dispatch(hideLoadingScreen());
    }
    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        let idLQT = +(params.get('id') || '');
        if (idLQT) {
            getById(idLQT);
        } else {
            const currentYear = dayjs().year();
            form.setFieldsValue({
                tenTieuDeCot: `Mức thù lao kế hoạch theo chức danh/tháng (năm ${currentYear})`
            });
            layThongTinCauHinh().then((setting) => {
                if (setting) {
                    form.setFieldsValue({
                        tenTieuDeCot: `Mức thù lao kế hoạch theo chức danh/tháng (năm ${currentYear})`,
                        mucThuLaoCTHDQL: (setting.thuLao_CTHDQL || 0) + "",
                        mucThuLaoCTHDQLStr: currencyFormat.formatMoney((setting.thuLao_CTHDQL || 0) + ""),
                        mucThuLaoPCTHDQL: (setting.thuLao_PCTHDQL || 0) + "",
                        mucThuLaoPCTHDQLStr: currencyFormat.formatMoney((setting.thuLao_PCTHDQL || 0) + ""),
                        mucThuLaoTVHDQL: (setting.thuLao_TVHDQL || 0) + "",
                        mucThuLaoTVHDQLStr: currencyFormat.formatMoney((setting.thuLao_TVHDQL || 0) + ""),
                        soThangLamViec: 3
                    });
                }
            }).catch(() => {});
        }
        getDataSelectThuLaoKCT(dayjs().year());
    }, [])

    return <section>
        {showModalDelete && <ModalTextForm show
            title="Xoá thù lao HĐQL không chuyên trách"
            handleClose={() => setShowModalDelete(false)}
            handleSave={eventDelete}>
            Xác nhận xóa thù lao HĐQL không chuyên trách
        </ModalTextForm>}
        {showModalDuyet && <ModalTextForm show
            title="Xác nhận thù lao HĐQL không chuyên trách"
            handleClose={() => setShowModalDuyet(false)}
            handleSave={eventXacNhan}>
            Xác nhận thù lao HĐQL không chuyên trách
        </ModalTextForm>}
        <ContentHeader title="Thù lao hội đồng quản lý không chuyên trách" />
        <Tabs
            tabBarExtraContent={
                <Space>
                    <Button type="default" icon={<ArrowLeftOutlined rev="" />} onClick={() => { navigate(Links.ThuLaoKhongChuyenTrach.DanhSach) } }>
                        Quay lại
                    </Button>
                    {
                        id > 0 &&
                        <Button
                            loading={isLoading}
                            className="hrm-btn hrm-btn-success"
                            icon={<DownloadOutlined rev="" />}
                            onClick={handleExport}
                        >Xuất excel
                        </Button>
                    }   
                    {trangThai <= 0 &&
                        <Button
                            type="default"
                            icon={<EditOutlined rev="" />}
                            onClick={() => {
                                setIsEdit(!isEdit);
                            }}
                        >
                            {
                                !isEdit ? "Chỉnh sửa" : "Khóa"
                            }
                        </Button>
                    }
                    {
                        id > 0 && trangThai == 0 &&
                        <Button
                            type="primary" danger
                            icon=<DeleteOutlined rev="" />
                            onClick={() => { setShowModalDelete(true) }}
                        >
                            Xóa
                        </Button>
                    }
                    {
                        id > 0 && (trangThai == 0 || trangThai == 2) && !isEdit &&
                        <Button
                            type="primary"
                            icon=<SaveOutlined rev="" />
                            onClick={() => { setShowModalDuyet(true) }}
                        >
                            Xác nhận
                        </Button>
                    }
                    {
                        (trangThai <= 0 || trangThai == undefined) &&
                        <Button
                            type="primary"
                            icon={<SaveOutlined rev="" />}
                            onClick={eventSaveThuLaoKCT}
                        >
                            Lưu
                        </Button>
                    }
                </Space>}
            defaultActiveKey="1" items={[
                {
                    key: "1",
                    label: "Thông tin",
                    children:
                        <Row>
                            <Col span="24" className="card card-body">
                                <Form
                                    layout="vertical"
                                    validateMessages={validateMessages}
                                    form={form}
                                >
                                    <Row gutter={12}>
                                        <Col span="12" >
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Tên kỳ tính thù lao" name="ten">
                                                <Input readOnly={trangThai > 0} />
                                            </Form.Item>
                                        </Col>
                                        <Col span="12">
                                            <Form.Item rules={[{ required: true, message: "Vui lòng nhập tiêu đề cột" }]} label="Tiêu đề cột Mức thù lao" name="tenTieuDeCot">
                                                <Input placeholder="Ví dụ: Mức thù lao kế hoạch theo chức danh/tháng (năm 2026)" disabled={trangThai >= 0} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={(loaiThuLao === 0 && !isTinhChiTiet) ? "4" : "6"}>
                                            <Form.Item rules={[
                                                {
                                                    required: true
                                                }
                                            ]} label="Loại thù lao" name="loaiThuLao">
                                                <Select notFoundContent="Không có dữ liệu"
                                                    disabled={trangThai >= 0}
                                                    options={optionsLoai}
                                                    loading={isLoading}
                                                    onChange={(e) => {
                                                        setLoaiThuLao(e);
                                                        if (e >= 1) {
                                                            setIsTinhChiTiet(false);
                                                            form.setFieldsValue({
                                                                'isTinhChiTiet': false,
                                                                'thuLaoBinhQuanMotThang': e === 2 ? '100' : form.getFieldValue('thuLaoBinhQuanMotThang') || '100',
                                                                'thuLaoBinhQuanMotThangStr': e === 2 ? '100' : form.getFieldValue('thuLaoBinhQuanMotThangStr') || '100',
                                                            });
                                                        }
                                                    }}
                                                    placeholder="Loại thù lao" />
                                            </Form.Item>
                                        </Col>
                                        {
                                            (loaiThuLao === 0) && <Col span="2">
                                                <Form.Item valuePropName="checked" name="isTinhChiTiet" label="Tính chi tiết">
                                                    <Checkbox disabled={id > 0} onChange={(e) => setIsTinhChiTiet(e.target.checked)} />
                                                </Form.Item>
                                            </Col>
                                        }
                                        {
                                            loaiThuLao === 0 && !isTinhChiTiet && <Col span="2">
                                                <Form.Item valuePropName="checked" name="isTinhPhanTram" label="Tính phần trăm">
                                                    <Checkbox disabled={id > 0} onChange={(e) => setIsTinhPhanTram(e.target.checked)} />
                                                </Form.Item>
                                            </Col>
                                        }
                                        {!isTinhChiTiet ?
                                            <Col span={loaiThuLao === 0 ? "4" : "6"}>
                                                <Form.Item rules={[
                                                    {
                                                        required: true
                                                    },
                                                ]} label={(loaiThuLao === 1 || loaiThuLao === 2 || loaiThuLao === 3) ? "Tỷ lệ tạm ứng" : isTinhPhanTram ? "Tỷ lệ % so với thù lao chức danh" : "Quỹ thù lao tạm ứng"} name="thuLaoBinhQuanMotThangStr">
                                                    <Input prefix={(loaiThuLao === 1 || loaiThuLao === 2 || loaiThuLao === 3 || (loaiThuLao === 0 && isTinhPhanTram)) ? "%" : "₫ "} disabled={trangThai >= 0}
                                                        onChange={handleChangeCurrency}
                                                    />
                                                </Form.Item>
                                                <Form.Item hidden name="thuLaoBinhQuanMotThang" >
                                                    <Input />
                                                </Form.Item>
                                            </Col> :
                                            <>
                                                <Col span="4">
                                                    <Form.Item rules={[
                                                        {
                                                            required: loaiThuLao <= 0 ? true : false
                                                        },
                                                    ]} label="Chọn kỳ thao tác" name="kyThaoTac" >
                                                        <RangePicker
                                                            changeOnBlur={true}
                                                            disabled={id > 0 ? true : false}
                                                            style={{ width: "100%" }}
                                                            format="[Tháng] MM"

                                                            onChange={(value, string) => {
                                                                let chiTietDuocNhanList = parseThangTuMang(string).map((item) =>
                                                                    new ChiTietDuocNhanKCT(
                                                                        item
                                                                    ))
                                                                setChiTietDuocNhan(chiTietDuocNhanList);
                                                            }}
                                                            picker="month" />
                                                    </Form.Item>
                                                </Col>
                                                {chiTietDuocNhan?.length > 0 && chiTietDuocNhan.map((item, index) => (
                                                    < Col span={loaiThuLao === 0 ? "4" : "6"} key={item.thoiGian + index.toString()}>
                                                        <label>Quỹ thù lao {item.ten}</label>
                                                        <Input prefix={(loaiThuLao === 0 && isTinhPhanTram) ? "%" : "₫ "} disabled={trangThai >= 0}
                                                            value={chiTietDuocNhan[index].quyThuLaoThangStr}
                                                            onChange={(e) => {
                                                                const { value } = e.target;
                                                                const parsedValue = value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
                                                                var format = currencyFormat.formatMoney(parsedValue);
                                                                chiTietDuocNhan[index].quyThuLaoThang = parseInt(parsedValue);
                                                                chiTietDuocNhan[index].quyThuLaoThangStr = format;
                                                                setChiTietDuocNhan([...chiTietDuocNhan]);
                                                            }}
                                                        />
                                                        <Input hidden value={chiTietDuocNhan[index].quyThuLaoThang} />
                                                    </Col>))}
                                            </>
                                        }
                                        {loaiThuLao !== 3 && <Col span="6">
                                            <Form.Item rules={[
                                                {
                                                    required: loaiThuLao <= 0 ? true : false
                                                },
                                            ]} label="Kỳ quyết toán" name="thoiGianQuyetToanQuy" hidden={loaiThuLao >= 1}>
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={id > 0 ? true : false}
                                                    style={{ width: "100%" }}
                                                    format="[Quý] Q/YYYY"
                                                    placeholder="Chọn thời gian"
                                                    picker="quarter" />
                                            </Form.Item>
                                            <Form.Item rules={[
                                                {
                                                    required: (loaiThuLao >= 1 && loaiThuLao != 3) ? true : false
                                                },
                                            ]} label="Năm" name="thoiGianQuyetToanNam" hidden={loaiThuLao <= 0}>
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={id > 0 ? true : false}
                                                    style={{ width: "100%" }}
                                                    format="YYYY"
                                                    onChange={(e, dateStr) => getDataSelectThuLaoKCT(parseInt(dateStr))}
                                                    placeholder="Chọn thời gian"
                                                    picker="year" />
                                            </Form.Item>
                                        </Col>}
                                        {
                                            loaiThuLao >= 1 && loaiThuLao < 3 &&
                                            <Col span="18">
                                                <Form.Item rules={[
                                                    {
                                                        required: false
                                                    }
                                                ]} label="Chọn các khoản đã nhận (tham chiếu)" name="dsQuyDieuChinh">
                                                    <Select notFoundContent="Không có dữ liệu"
                                                        disabled={trangThai >= 0}
                                                        options={optionDieuChinh}
                                                        loading={isLoading}
                                                        mode="multiple"
                                                        placeholder="Chọn các khoản đã nhận (có thể để trống)" />
                                                </Form.Item>
                                            </Col>
                                        }
                                        {loaiThuLao === 3 && <Col span="6">
                                            <Form.Item
                                                label="Tháng năm" name="thangNam" rules={[
                                                    {
                                                        required: loaiThuLao === 3 ? true : false
                                                    }]
                                                }
                                            >
                                                <DatePicker
                                                    changeOnBlur={true}
                                                    disabled={trangThai > 0}
                                                    picker="month"
                                                    style={{ width: "100%" }}
                                                    placeholder="Chọn tháng"
                                                    format={["MM/YYYY", "MMYYYY"]}
                                                    allowClear={false}
                                                />
                                            </Form.Item>
                                        </Col>}
                                    </Row>
                                    { (loaiThuLao === 1 || loaiThuLao === 2 || loaiThuLao === 3) && (
                                        <Row gutter={12}>
                                            <Col span={6}>
                                                <Form.Item
                                                    rules={[{ required: true }]}
                                                    label="Thù lao CTHĐQL / tháng"
                                                    name="mucThuLaoCTHDQLStr"
                                                >
                                                    <Input
                                                        prefix="₫ "
                                                        disabled={trangThai >= 0}
                                                        onChange={handleChangeCurrencyCommon('mucThuLaoCTHDQL', 'mucThuLaoCTHDQLStr')}
                                                    />
                                                </Form.Item>
                                                <Form.Item hidden name="mucThuLaoCTHDQL">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    rules={[{ required: true }]}
                                                    label="Thù lao PCTHĐQL / tháng"
                                                    name="mucThuLaoPCTHDQLStr"
                                                >
                                                    <Input
                                                        prefix="₫ "
                                                        disabled={trangThai >= 0}
                                                        onChange={handleChangeCurrencyCommon('mucThuLaoPCTHDQL', 'mucThuLaoPCTHDQLStr')}
                                                    />
                                                </Form.Item>
                                                <Form.Item hidden name="mucThuLaoPCTHDQL">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            <Col span={6}>
                                                <Form.Item
                                                    rules={[{ required: true }]}
                                                    label="Thù lao TVHĐQL / tháng"
                                                    name="mucThuLaoTVHDQLStr"
                                                >
                                                    <Input
                                                        prefix="₫ "
                                                        disabled={trangThai >= 0}
                                                        onChange={handleChangeCurrencyCommon('mucThuLaoTVHDQL', 'mucThuLaoTVHDQLStr')}
                                                    />
                                                </Form.Item>
                                                <Form.Item hidden name="mucThuLaoTVHDQL">
                                                    <Input />
                                                </Form.Item>
                                            </Col>
                                            {(loaiThuLao === 1 || loaiThuLao === 3 || loaiThuLao === 2) && (
                                                <Col span={6}>
                                                    <Form.Item
                                                        rules={[{ required: true }]}
                                                        label="Số tháng làm việc"
                                                        name="soThangLamViec"
                                                    >
                                                        <Input
                                                            type="number"
                                                            min={1}
                                                            max={36}
                                                            disabled={trangThai >= 0}
                                                            placeholder="Số tháng"
                                                        />
                                                    </Form.Item>
                                                </Col>
                                            )}
                                        </Row>
                                    )}
                                    <Row gutter={12}>
                                        <Col span="24">
                                            <Form.Item label="Ghi chú" name="ghiChu">
                                                {trangThai <= 0 ? (
                                                    <Input.TextArea rows={3} placeholder="Nhập ghi chú..." />
                                                ) : (
                                                    <div style={{ whiteSpace: 'pre-wrap', minHeight: '40px', background: '#f5f5f5', padding: '10px', borderRadius: '4px' }}>
                                                        {watchGhiChu || 'Không có ghi chú'}
                                                    </div>
                                                )}
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                    <Row gutter={12}>
                                        {
                                            id > 0 &&
                                            <Col span="6">
                                                <Form.Item label="Trạng thái">
                                                    {
                                                        trangThai == 0 &&
                                                        <Tag color="processing">Khởi tạo</Tag>
                                                    }
                                                    {
                                                        trangThai == 1 &&
                                                        <Tag color="success">Đã duyệt</Tag>
                                                    }
                                                    {
                                                        trangThai == 2 &&
                                                        <Tag color="warning">Trình duyệt</Tag>
                                                    }
                                                </Form.Item>
                                            </Col>
                                        }
                                    </Row>
                                    {
                                        id == 0 && trangThai < 0 ?
                                            <Row>
                                                <Space>
                                                    <Button
                                                        onClick={taiDuLieu}
                                                        type="primary"
                                                        loading={isLoading}
                                                        icon={<ReloadOutlined rev="" />}>
                                                        Tải dữ liệu tính thù lao KCT
                                                    </Button>
                                                </Space>
                                            </Row> : null
                                    }
                                </Form>
                            </Col>
                        </Row>
                }]} />
        {trangThai <= 0 &&
            <Row>
                <Col>

                </Col>
            </Row>
        }
        <div className="card card-primary mt-2">
            <Table
                sticky
                scroll={{ x: dataThuLaoKCT.length > 0 && dataThuLaoKCT[0]?.chiTietDuocNhan?.length > 0 ? 3000 : 2000 }}
                loading={isLoading}
                dataSource={(dataThuLaoKCT || []).map((value, index) => { const item = { key: index, ...value }; return item; })}
                locale={{ emptyText: "Không có dữ liệu" }}
                pagination={false}
                bordered={true}
                summary={pageData => {
                    let totalMucLuongConDuocNhan = 0;
                    let totalMucLuongDuocNhan = 0;
                    let totalThuLaoTheoChucDanh = 0;
                    let totalTongThuLao = 0;
                    let totalThuLaoTamUngMotThang = 0;
                    var dataThang: number[] = [];
                    var dataThangDuocNhan: number[] = [];
                    pageData.forEach(({ soTienConDuocNhan, soTienDuocNhan, thuLaoTheoChucDanh, thuLaoTamUngMotThang, tongThuLao, chiTietDaNhan, chiTietDuocNhan }) => {
                        totalMucLuongConDuocNhan += soTienConDuocNhan;
                        totalMucLuongDuocNhan += soTienDuocNhan;
                        totalThuLaoTheoChucDanh += thuLaoTheoChucDanh;
                        totalTongThuLao += tongThuLao;
                        totalThuLaoTamUngMotThang += thuLaoTamUngMotThang;

                        chiTietDaNhan?.forEach((item: any, idx: number) => {
                            if (dataThang.length - 1 < idx) dataThang.push(0);
                            dataThang[idx] += item.mucTien;
                        });

                        chiTietDuocNhan?.forEach((item: any, idx: number) => {
                            if (dataThangDuocNhan.length - 1 < idx) dataThangDuocNhan.push(0);
                            dataThangDuocNhan[idx] += item.mucTien;
                        });
                    });

                    const totalSoTienDaNhan = dataThuLaoKCT.reduce((a, b) => a + (b.soTienDaNhan || 0), 0);
                    return (
                        <>
                            {/* loaiThuLao === 3 (Tạm ứng hàng tháng) */}
                            {loaiThuLao === 3 &&
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} key="1e" colSpan={2} align="left"><label>Tổng cộng</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} key="2e" align="right"><label>{formatVND(dataThuLaoKCT.reduce((a, b) => a + (b.mucLuongCB || 0), 0))}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={2} key="3e" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3} key="4e" align="right"><label>{formatVND(totalThuLaoTamUngMotThang)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4} key="5e" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={5} key="6e" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={6} key="7e" align="right"><label>{formatVND(totalMucLuongConDuocNhan)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={7} key="8e" align="right"></Table.Summary.Cell>
                                </Table.Summary.Row>
                            }

                            {/* loaiThuLao === 0, !isTinhChiTiet */}
                            {loaiThuLao === 0 && !isTinhChiTiet &&
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} key="1a" colSpan={2} align="left"><label>Tổng cộng</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} key="2a" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={2} key="3a" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3} key="4a" align="right"><label>{formatVND(totalThuLaoTheoChucDanh)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4} key="5a" align="right"><label>{formatVND(totalThuLaoTamUngMotThang)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={5} key="6a" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={6} key="7a" align="right"><label>{formatVND(totalMucLuongConDuocNhan)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={7} key="8a" align="right"></Table.Summary.Cell>
                                </Table.Summary.Row>
                            }

                            {/* loaiThuLao === 0, isTinhChiTiet */}
                            {loaiThuLao === 0 && isTinhChiTiet &&
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} key="1b" colSpan={2} align="left"><label>Tổng cộng</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} key="2b" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={2} key="3b" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3} key="4b" align="right"><label>{formatVND(totalThuLaoTheoChucDanh)}</label></Table.Summary.Cell>
                                    {dataThangDuocNhan.map((item: number, idx: number) => (
                                        <Table.Summary.Cell key={item.toString() + idx.toString()} index={4 + idx} align="right">
                                            <label>{formatVND(item)}</label>
                                        </Table.Summary.Cell>
                                    ))}
                                    <Table.Summary.Cell index={4 + dataThangDuocNhan.length} key="5b" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={5 + dataThangDuocNhan.length} key="6b" align="right"><label>{formatVND(totalMucLuongConDuocNhan)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={6 + dataThangDuocNhan.length} key="7b" align="right"></Table.Summary.Cell>
                                </Table.Summary.Row>
                            }

                            {/* loaiThuLao === 1 || loaiThuLao === 2 */}
                            {(loaiThuLao === 1 || loaiThuLao === 2) &&
                                <Table.Summary.Row>
                                    <Table.Summary.Cell index={0} key="1cd" colSpan={2} align="left"><label>Tổng cộng</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={1} key="2cd" align="right"><label>{formatVND(dataThuLaoKCT.reduce((a, b) => a + (b.mucLuongCB || 0), 0))}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={2} key="3cd" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={3} key="4cd" align="right"><label>{formatVND(totalThuLaoTamUngMotThang)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={4} key="5cd" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={5} key="6cd" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={6} key="7cd" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={7} key="8cd" align="right"></Table.Summary.Cell>
                                    <Table.Summary.Cell index={8} key="9cd" align="right"><label>{formatVND(totalMucLuongDuocNhan)}</label></Table.Summary.Cell>
                                    {dataThang.map((item: number, idx: number) => (
                                        <Table.Summary.Cell key={item.toString() + idx.toString()} index={9 + idx} align="right">
                                            <label>{formatVND(item)}</label>
                                        </Table.Summary.Cell>
                                    ))}
                                    <Table.Summary.Cell index={9 + dataThang.length} key="11cd" align="right"><label>{formatVND(totalSoTienDaNhan)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={10 + dataThang.length} key="12cd" align="right"><label>{formatVND(totalMucLuongConDuocNhan)}</label></Table.Summary.Cell>
                                    <Table.Summary.Cell index={11 + dataThang.length} key="13cd" align="right"></Table.Summary.Cell>
                                </Table.Summary.Row>
                            }
                        </>
                    );
                }}
            >
                <Column title="Họ và tên" key="hoTen" dataIndex="hoTen" fixed />
                <Column title="Chức vụ" key="tenChucVu" dataIndex="tenChucVu" fixed />
                <Column
                    title={form.getFieldValue('tenTieuDeCot') || (loaiThuLao === 3 ? "Mức thù lao kế hoạch theo chức danh/tháng (năm 2026)" : "Mức thù lao kế hoạch theo chức danh/tháng (năm 2026)")}
                    className="custom-column"
                    key="mucLuongCB"
                    dataIndex="mucLuongCB"
                    render={(value) => formatVND(value)}
                />
                <Column
                    title="Tỷ lệ tạm ứng"
                    align="center"
                    key="tyLe"
                    dataIndex="tyLe"
                    render={(value, record: any, idx: number) => {
                        if (isEdit && loaiThuLao === 3) {
                            return (
                                <Input
                                    style={{ width: 70, textAlign: "center" }}
                                    value={Math.round((value ?? 1) * 100)}
                                    type="number"
                                    min={0}
                                    max={100}
                                    onChange={(e) => {
                                        var v = (parseFloat(e.target.value) || 0) / 100;
                                        dataThuLaoKCT[idx].tyLe = v;
                                        recalculateRow(dataThuLaoKCT[idx]);
                                        setDataThuLaoKCT([...dataThuLaoKCT]);
                                    }}
                                />
                            );
                        }
                        var pct = Math.round((value != null ? value : (form.getFieldValue('thuLaoBinhQuanMotThang') ? parseInt(form.getFieldValue('thuLaoBinhQuanMotThang')) / 100 : 1)) * 100);
                        return <>{pct}%</>;
                    }}
                />
                <Column
                    title="Mức thù lao tạm ứng/tháng"
                    className="custom-column"
                    key="thuLaoTamUngMotThang"
                    dataIndex="thuLaoTamUngMotThang"
                    render={(value) => formatVND(value)}
                />

                {/* Loai 3: Tạm ứng 1 tháng */}
                {loaiThuLao === 3 && (
                    <Column
                        title="Số ngày làm việc thực tế trong tháng"
                        align="center"
                        key="soNgayThucTe"
                        dataIndex="soNgayThucTe"
                        render={(value, record: any, idx: number) => {
                            if (isEdit) {
                                return (
                                    <Input
                                        style={{ width: 70, textAlign: "center" }}
                                        value={value ?? soNgayCongMacDinh}
                                        type="number"
                                        min={0}
                                        onChange={(e) => {
                                            const val = e.target.value === "" ? 0 : Number(e.target.value);
                                            dataThuLaoKCT[idx].soNgayThucTe = val;
                                            recalculateRow(dataThuLaoKCT[idx]);
                                            setDataThuLaoKCT([...dataThuLaoKCT]);
                                        }}
                                    />
                                );
                            }
                            return value ?? soNgayCongMacDinh;
                        }}
                    />
                )}
                {loaiThuLao === 3 && (
                    <Column
                        title="Số ngày làm việc của tháng"
                        align="center"
                        key="soNgayQuyDinh"
                        dataIndex="soNgayQuyDinh"
                        render={(value, record: any, idx: number) => {
                            if (isEdit) {
                                return (
                                    <Input
                                        style={{ width: 70, textAlign: "center" }}
                                        value={value ?? soNgayCongMacDinh}
                                        type="number"
                                        min={1}
                                        onChange={(e) => {
                                            const val = e.target.value === "" ? soNgayCongMacDinh : Number(e.target.value);
                                            dataThuLaoKCT[idx].soNgayQuyDinh = val;
                                            recalculateRow(dataThuLaoKCT[idx]);
                                            setDataThuLaoKCT([...dataThuLaoKCT]);
                                        }}
                                    />
                                );
                            }
                            return value ?? soNgayCongMacDinh;
                        }}
                    />
                )}
                {loaiThuLao === 3 && (
                    <Column
                        title="Tổng thù lao tạm ứng"
                        className="custom-column"
                        key="soTienConDuocNhan"
                        dataIndex="soTienConDuocNhan"
                        render={(value) => formatVND(value)}
                    />
                )}

                {/* Loai 0: Cách tính cũ */}
                {loaiThuLao === 0 && <Column title="Thù lao theo chức danh" className="custom-column" key="thuLaoTheoChucDanh" dataIndex="thuLaoTheoChucDanh" render={(value) => formatVND(value)} />}
                {loaiThuLao === 0 && (
                    <Column
                        title="Số tháng làm việc"
                        align="center"
                        key="soThangLamViec"
                        dataIndex="soThangLamViec"
                        render={(value, record, idx) => {
                            if (isEdit && !isTinhChiTiet) {
                                return (
                                    <Input
                                        key={idx}
                                        value={value}
                                        type="number"
                                        onChange={(e) => {
                                            const val = e.target.value === "" ? 0 : parseInt(e.target.value);
                                            dataThuLaoKCT[idx].soThangLamViec = val;
                                            dataThuLaoKCT[idx].soTienDuocNhan = dataThuLaoKCT[idx].thuLaoTamUngMotThang * val;
                                            dataThuLaoKCT[idx].soTienConDuocNhan = dataThuLaoKCT[idx].soTienDuocNhan - (dataThuLaoKCT[idx].soTienDaNhan || 0);
                                            setDataThuLaoKCT([...dataThuLaoKCT]);
                                        }}
                                    />
                                );
                            }
                            return value;
                        }}
                    />
                )}
                {loaiThuLao === 0 && (
                    <Column
                        title="Thành tiền"
                        className="custom-column"
                        key="soTienConDuocNhan"
                        dataIndex="soTienConDuocNhan"
                        render={(value) => formatVND(value)}
                    />
                )}

                {(loaiThuLao === 1 || loaiThuLao === 2) && (
                    <ColumnGroup title="Bao gồm">
                        <Column
                            title="Số tháng làm việc (tròn tháng)"
                            align="center"
                            key="soThangTron"
                            dataIndex="soThangTron"
                            render={(value, record: any, idx: number) => {
                                if (isEdit) {
                                    return (
                                        <Input
                                            style={{ width: 60, textAlign: "center" }}
                                            value={value ?? 0}
                                            type="number"
                                            min={0}
                                            onChange={(e) => {
                                                const val = e.target.value === "" ? 0 : parseInt(e.target.value);
                                                dataThuLaoKCT[idx].soThangTron = val;
                                                recalculateRow(dataThuLaoKCT[idx]);
                                                setDataThuLaoKCT([...dataThuLaoKCT]);
                                            }}
                                        />
                                    );
                                }
                                return value ?? 0;
                            }}
                        />
                        <Column
                            title="Số tháng làm việc (không tròn tháng)"
                            align="center"
                            key="dsThangKhongTron"
                            dataIndex="dsThangKhongTron"
                            render={(value: any[], record: any, idx: number) => {
                                const list = value || [];
                                if (isEdit) {
                                    return (
                                        <Space direction="vertical" style={{ width: '100%' }} size={4}>
                                            {list.map((item: any, ktIdx: number) => (
                                                <div key={ktIdx} style={{ display: 'flex', justifyContent: 'center', height: '32px', alignItems: 'center' }}>
                                                    <Input
                                                        style={{ width: 50, textAlign: 'center' }}
                                                        type="number"
                                                        min={0}
                                                        value={item.soThang ?? 1}
                                                        onChange={(e) => {
                                                            const v = e.target.value === "" ? 0 : parseInt(e.target.value);
                                                            item.soThang = v;
                                                            recalculateRow(dataThuLaoKCT[idx]);
                                                            setDataThuLaoKCT([...dataThuLaoKCT]);
                                                        }}
                                                    />
                                                </div>
                                            ))}
                                            <Button
                                                size="small"
                                                type="dashed"
                                                icon={<PlusOutlined rev="" />}
                                                onClick={() => {
                                                    if (!dataThuLaoKCT[idx].dsThangKhongTron) {
                                                        dataThuLaoKCT[idx].dsThangKhongTron = [];
                                                    }
                                                    dataThuLaoKCT[idx].dsThangKhongTron.push({
                                                        soThang: 1,
                                                        soNgayThucTe: 0,
                                                        soNgayQuyDinh: soNgayCongMacDinh,
                                                        ghiChu: ""
                                                    });
                                                    recalculateRow(dataThuLaoKCT[idx]);
                                                    setDataThuLaoKCT([...dataThuLaoKCT]);
                                                }}
                                            >
                                                Thêm
                                            </Button>
                                        </Space>
                                    );
                                }
                                if (list.length === 0) return 0;
                                return (
                                    <Space direction="vertical" style={{ width: '100%' }} size={4}>
                                        {list.map((item: any, ktIdx: number) => (
                                            <div key={ktIdx} style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                {item.soThang ?? 1}
                                            </div>
                                        ))}
                                    </Space>
                                );
                            }}
                        />
                        <ColumnGroup title="Trong đó">
                            <Column
                                title="Số ngày làm việc thực tế"
                                align="center"
                                key="soNgayThucTe"
                                render={(record: any, _, idx: number) => {
                                    const list = record.dsThangKhongTron || [];
                                    if (isEdit) {
                                        return (
                                            <Space direction="vertical" style={{ width: '100%' }} size={4}>
                                                {list.map((item: any, ktIdx: number) => (
                                                    <div key={ktIdx} style={{ display: 'flex', justifyContent: 'center', height: '32px', alignItems: 'center' }}>
                                                        <Input
                                                            style={{ width: 60, textAlign: 'center' }}
                                                            type="number"
                                                            min={0}
                                                            value={item.soNgayThucTe ?? 0}
                                                            onChange={(e) => {
                                                                const v = e.target.value === "" ? 0 : parseInt(e.target.value);
                                                                item.soNgayThucTe = v;
                                                                recalculateRow(dataThuLaoKCT[idx]);
                                                                setDataThuLaoKCT([...dataThuLaoKCT]);
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                                {list.length === 0 && <div style={{ height: '24px' }}>-</div>}
                                            </Space>
                                        );
                                    }
                                    if (list.length === 0) return "-";
                                    return (
                                        <Space direction="vertical" style={{ width: '100%' }} size={4}>
                                            {list.map((item: any, ktIdx: number) => (
                                                <div key={ktIdx} style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {item.soNgayThucTe ?? 0}
                                                </div>
                                            ))}
                                        </Space>
                                    );
                                }}
                            />
                            <Column
                                title="Số ngày quy định trong tháng"
                                align="center"
                                key="soNgayQuyDinh"
                                render={(record: any, _, idx: number) => {
                                    const list = record.dsThangKhongTron || [];
                                    if (isEdit) {
                                        return (
                                            <Space direction="vertical" style={{ width: '100%' }} size={4}>
                                                {list.map((item: any, ktIdx: number) => (
                                                    <div key={ktIdx} style={{ display: 'flex', justifyContent: 'center', height: '32px', alignItems: 'center', gap: '4px' }}>
                                                        <Input
                                                            style={{ width: 60, textAlign: 'center' }}
                                                            type="number"
                                                            min={1}
                                                            value={item.soNgayQuyDinh ?? soNgayCongMacDinh}
                                                            onChange={(e) => {
                                                                const v = e.target.value === "" ? soNgayCongMacDinh : parseInt(e.target.value);
                                                                item.soNgayQuyDinh = v;
                                                                recalculateRow(dataThuLaoKCT[idx]);
                                                                setDataThuLaoKCT([...dataThuLaoKCT]);
                                                            }}
                                                        />
                                                        <Button
                                                            type="text"
                                                            danger
                                                            size="small"
                                                            icon={<MinusCircleOutlined rev="" />}
                                                            onClick={() => {
                                                                dataThuLaoKCT[idx].dsThangKhongTron.splice(ktIdx, 1);
                                                                recalculateRow(dataThuLaoKCT[idx]);
                                                                setDataThuLaoKCT([...dataThuLaoKCT]);
                                                            }}
                                                        />
                                                    </div>
                                                ))}
                                                {list.length === 0 && <div style={{ height: '24px' }}>-</div>}
                                            </Space>
                                        );
                                    }
                                    if (list.length === 0) return "-";
                                    return (
                                        <Space direction="vertical" style={{ width: '100%' }} size={4}>
                                            {list.map((item: any, ktIdx: number) => (
                                                <div key={ktIdx} style={{ height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    {item.soNgayQuyDinh ?? soNgayCongMacDinh}
                                                </div>
                                            ))}
                                        </Space>
                                    );
                                }}
                            />
                        </ColumnGroup>
                    </ColumnGroup>
                )}

                {/* Cột (9) Thù lao được nhận cho Loại 1, 2 */}
                {(loaiThuLao === 1 || loaiThuLao === 2) && (
                    <Column
                        title="Thù lao được nhận"
                        className="custom-column"
                        key="soTienDuocNhan"
                        dataIndex="soTienDuocNhan"
                        render={(value) => formatVND(value)}
                    />
                )}

                {/* Các cột thù lao tham chiếu */}
                {(loaiThuLao === 1 || loaiThuLao === 2) && dataThuLaoKCT.length > 0 && dataThuLaoKCT[0]?.chiTietDaNhan?.length > 0 && (
                    <ColumnGroup key={dataThuLaoKCT[0].id} title="Thù lao đã nhận (tham chiếu)">
                        {(dataThuLaoKCT[0].chiTietDaNhan || []).map((item: any, idx: number) => (
                            <Column
                                title={item.ten}
                                key={item.thoiGian + idx}
                                className="custom-column"
                                render={(value) => formatVND(value?.chiTietDaNhan[idx]?.mucTien)}
                            />
                        ))}
                    </ColumnGroup>
                )}

                {/* Cột (10) Thù lao đã nhận cho Loại 1, 2 */}
                {(loaiThuLao === 1 || loaiThuLao === 2) && (
                    <Column
                        title="Thù lao đã nhận"
                        className="custom-column"
                        key="soTienDaNhan"
                        dataIndex="soTienDaNhan"
                        render={(value, record: any, idx: number) => {
                            if (isEdit) {
                                return (
                                    <Input
                                        style={{ width: 120, textAlign: 'right' }}
                                        value={currencyFormat.formatMoney((value ?? 0) + "")}
                                        onChange={(e) => {
                                            const parsed = e.target.value.replace(/[^0-9]/g, '').trim().replace(/^0+/, '');
                                            const val = parsed ? parseInt(parsed) : 0;
                                            dataThuLaoKCT[idx].soTienDaNhan = val;
                                            recalculateRow(dataThuLaoKCT[idx]);
                                            setDataThuLaoKCT([...dataThuLaoKCT]);
                                        }}
                                    />
                                );
                            }
                            return formatVND(value || 0);
                        }}
                    />
                )}

                {/* Cột (11) Thù lao còn được nhận cho Loại 1, 2 */}
                {(loaiThuLao === 1 || loaiThuLao === 2) && (
                    <Column
                        title="Thù lao còn được nhận"
                        className="custom-column"
                        key="soTienConDuocNhan"
                        dataIndex="soTienConDuocNhan"
                        render={(value) => formatVND(value)}
                    />
                )}

                <Column
                    title="Ghi chú"
                    key="ghiChu"
                    dataIndex="ghiChu"
                    render={(value, record, idx) => {
                        if (isEdit) {
                            return (
                                <Input
                                    value={value}
                                    onChange={(e) => {
                                        dataThuLaoKCT[idx].ghiChu = e.target.value;
                                        setDataThuLaoKCT([...dataThuLaoKCT]);
                                    }}
                                />
                            );
                        }
                        return value;
                    }}
                />
            </Table>
        </div>
    </section >
}

export default ChiTietThuLaoKCT;